import template from './invoice-create.html';
import controller from './invoice-create.controller';

let invoiceComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default invoiceComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/invoice-create/invoice-create.component.js